import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"
var pdev = "/assessment"
const purl1 = pdev + '/manager/login';
const purl2 = pdev + '/manager'
const purl3 = pdev + '/manager/checkPassword/'

let url = "/sys/user";
let url2 = "/sys/press_user"; //期刊管理
let url5 = "/sys/subject"; //学科管理

const url3 = '/manager/menu/tree-by-role' //菜单
const url4 = '/info' //获取详细用户信息
const url6 = "/sms/sendCode"; //获取短信验证码
const url7 = "/sms/valid/first-login"; //验证短信验证码"
const url8 = "/account/modify-password-by-user"; // 根据userId修改密码
const url9 = "/account/modify-password-by-phone"; // 根据验证码修改密码
const url10 = "/sms/validCode"; // 验证验证码
const url14 = '/mobile/student/get-parent-phone'; //通过学籍号获取家长手机号
const url15 = '/kaptcha'; //获取图片验证码
const url16 = '/account/modify-password-by-oldpassword'; //根据旧密码吗修改新密码

let url18 = "/web/sso"; //帮助中心
const url21 = '/setting'; //获取设置相关数据
const url22 = '/manager/stage/time-line'; //获取当前评价阶段,时间轴信息
let url19 = "/web/message"; //用户反馈/sys/message

const apis = {
	//问题列表翻页
	question(data) {
		return request({
			url: url18 + "/question",
			method: 'get',
			params: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	//获取帮助视频地址

	webViewBill(invoicePath) {
		return request({
			url: "/web/myOrder/webViewBill",
			method: 'get',
			params: {
				invoicePath: invoicePath
			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	getFilePath(data) {
		return request({
			url: url18 + "/getFilePath",
			method: 'get',
			params: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	//删除问题
	delQuestion(data) {
		return request({
			url: url18 + "/question",
			method: 'delete',
			jsonString: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	feedbackList(data) { //用户反馈列表
		return request({
			url: url19 + "/queryMessageList",
			method: 'post',
			data: data,
			isToken: true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	deleteFeedbackDetailById(data) { // 删除收件箱消息，反馈删除也走此接口
		return request({
			url: url19 + "/deleteMessageForReceiver",
			method: 'delete',
			data: data,
			isToken: true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	queryFeedbackDetailById(data) { // 收件箱（或问题反馈）通过id查询邮件详情
		return request({
			url: url19 + "/queryMessageByIdForReceiver",
			method: 'post',
			data: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	addWebFeedback(data) { // 意见反馈添加
		return request({
			url: url19 + "/addWebFeedback",
			method: 'post',
			data: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	findAdminUserList(data) { // 意见反馈添加
		return request({
			url: url19 + "/findAdminUserList",
			method: 'post',
			data: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	login(data) { //登录
		return request({
			url: url + "/login",
			method: 'post',
			//       isToken:true,
			//       jsonString:true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	logout(userId) { //退出
		return request({
			url: url + "/logout",
			method: 'post',
			data: {
				userId: userId,
			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	pressUserList(data) { //期刊管理列表
		return request({
			url: url2 + "/pressUserList",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	insertPressUser(data) { //添加期刊管理员
		return request({
			url: url2 + "/insertPressUser",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	delPressUser(data) { //期刊管理删除
		return request({
			url: url2 + "/delPressUser",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	isForbidden(data) { //期刊管理禁用
		return request({
			url: url2 + "/isForbidden",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	isContribute(data) { //更改期刊社收稿状态
		return request({
			url: url2 + "/isContribute",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	resetPwd(data) { //重置密码
		return request({
			url: url + "/resetPwd",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	updPressUser(data) { //修改期刊管理员
		return request({
			url: url2 + "/updPressUser",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	selPressUser(data) { //根据用户id查询期刊社管理员信息
		return request({
			url: url2 + "/selPressUser",
			method: 'post',
			isToken: true,
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	//一级学科列表
	findOneList() {
		return request({
			url: url5 + "/findOneList",
			method: 'get',
			params: {

			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//二级学科列表
	findTwoList(code, name) {
		return request({
			url: url5 + "/findTwoList",
			method: 'get',
			params: {
				code: code,
				name: name,

			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	//查询学科信息
	findSubject(subjectId) {
		return request({
			url: url5 + "/findSubject",
			method: 'get',
			params: {
				id: subjectId,

			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	open(data) { // 状态开关
		return request({
			url: url5 + "/open",
			method: 'post',
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	updateSubject(data) { // 修改学科
		return request({
			url: url5 + "/updateSubject",
			method: 'post',
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	addSubject(data) { //增加学科
		return request({
			url: url5 + "/addSubject",
			method: 'post',
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	getImgTest(data) { //登录
		return request({
			url: url15,
			method: 'get',
			baseConfing: {
				responseType: "blob"
			},
			params: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	setNewPassWord(data) {
		return request({
			url: url16,
			method: 'put',
			data: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	getParenthone(data) {
		return request({
			url: url14,
			method: 'get',
			params: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	resetPSD(userId, userType) {
		return request({
			url: "/account/reset-password",
			method: 'get',
			params: {
				userId: userId,
				userType: userType,
			},
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	validCode(data) {
		return request({
			url: url10,
			method: 'post',
			data: data
		})
	},
	getCode(data) {
		return request({
			url: url6,
			method: 'post',
			data: data
		})
	},
	codeSetPass(data) {
		return request({
			url: url9,
			method: 'put',
			data: data
		})
	},
	testCode(data) {
		return request({
			url: url7,
			method: 'post',
			data: data
		})
	},
	setPassWord(data) {
		return request({
			url: url8,
			method: 'put',
			data: data
		})
	},
	getUserInfo(id) {
		return request({
			url: url2 + '/' + id,
			method: 'get',
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	checkPassword(data) { //教研密码是否正确
		return request({
			url: purl3 + data.userId,
			method: 'get',
			data: {
				userId: data.userId,
				password: data.password
			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	resetPassword(data) { //教研密码是否正确
		return request({
			url: purl2,
			method: 'put',
			jsonString: true,
			data: {
				id: data.id,
				password: data.password,
			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	menuList(roleId) {
		return request({
			url: url3,
			method: 'get',
			params: {
				roleId: roleId
			}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	// 通过用户类型 && 用户id
	getUserDetails(data) {
		return request({
			url: url4,
			method: 'get',
			params: data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	logOut() { //注销
		return request({
			url: url5,
			method: 'delete',
		}).then((resault) => {
			// //console.log(resault)
			return Promise.resolve(resault.data)
		})
	},

	// 获取设置相关数据
	getSetting() {
		return request({
			url: url21,
			method: 'get',
		}).then((resault) => {
			// //console.log(resault)
			return Promise.resolve(resault.data)
		})
	},

	// 获取当前评价阶段,时间轴信息
	getSteps() {
		return request({
			url: url22,
			method: 'get',
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	getUserInfo() { //个人资料
		return request({
			url: "/web/sso/getUserInfo",
			method: 'get',
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	setUserInfo(data) { //个人资料保存
		return request({
			url: "/web/sso/setUserInfo",
			method: 'post',
			data: data,
			jsonString: true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	ssoSubject(prevId) { //个人资料保存
		return request({
			url: "/web/ssoSubject/list",
			method: 'get',
			params: {
				prevId: prevId || 0
			},
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	/*订单查询*/
	invoiceList(data) { //开票查询列表
		return request({
			url: "/web/articleManage/invoiceList",
			method: 'get',
			params: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	queryBilldetails(data) { //开票详情
		return request({
			url: "/web/articleManage/queryBilldetails",
			method: 'get',
			params: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	confirmInvoiceBill(data) { //开票保存
		return request({
			url: "/web/articleManage/confirmInvoiceBill",
			method: 'post',
			data: data,
			jsonString: true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	returnBill(data) { //开票撤回
		return request({
			url: "/web/articleManage/returnBill",
			method: 'delete',
			data: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	viewBill(data) { //pdf
		return request({
			url: "/web/articleManage/viewBill",
			method: 'get',
			params: data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

}

export default apis


// WEBPACK FOOTER //
// ./src/core/api/manage.serve.js